import React from "react";
import { RCCBadge, RCCHidden } from "react-common-components";
import { useHistory } from "react-router-dom";
import { useTranslation } from "src/context/Translations/context";
import { IDashboardOKRsData } from "../interface";

interface ILI{
    data?: IDashboardOKRsData;
	level?: string;
	showLink?: boolean;
}

const Li: React.FC<ILI> = ({
	data,
	level,
	showLink
}) => {
	const { translate } = useTranslation();
	const history = useHistory();

	return (
		<>
			<div>
				<RCCBadge color="purple" layout="isSquare" onClick={showLink ? () => history.push(`/okr/panel?group=3&list=T&level=${level}`) : undefined} >{data?.total || 0}</RCCBadge>
				<RCCHidden mdUp>
					{translate("Total")}
				</RCCHidden>
			</div>
			<div>
				<RCCBadge color="blue" layout="isSquare" >{data?.withoutValue || 0}</RCCBadge>
				<RCCHidden mdUp>
					{translate("Sem checkin")}
				</RCCHidden>
			</div>
			<div>
				<RCCBadge color="yellow" layout="isSquare" >{data?.notOnTarget || 0}</RCCBadge>
				<RCCHidden mdUp>
					{translate("Checkin parcial")}
				</RCCHidden>
			</div>
			<div>
				<RCCBadge color="red" layout="isSquare" >{data?.delayed || 0}</RCCBadge>
				<RCCHidden mdUp>
					{translate("Atrasado")}
				</RCCHidden>
			</div>
			<div>
				<RCCBadge color="green" layout="isSquare" >{data?.onTarget || 0}</RCCBadge>
				<RCCHidden mdUp>
					{translate("Atingiu a meta")}
				</RCCHidden>
			</div>
		</>
	);
};

export default Li;
